import {
    createBaseQueries,
    transformErrorResponse,
    transformSuccessResponse,
    buildFormData,
    EXTERNAL_URL,
} from "@/services";
import { createApi } from "@reduxjs/toolkit/query/react";

const { rawExternalApiBaseQuery: studentNotificationBaseQuery } = createBaseQueries({
    externalURLType: EXTERNAL_URL.appRoot,
});

const studentNotificationAPI = createApi({
    reducerPath: "studentNotificationAPI",
    baseQuery: studentNotificationBaseQuery,
    tagTypes: ["StudentNotification"],
    endpoints: (builder) => ({
        getStudentNotificationList: builder.query({
            query: ({ page = 0, size = 10, searchText = "", sortBy = "", sortDir = "" } = {}) => ({
                url: `/util/notification`,
                method: "GET",
                params: {
                    page,
                    size,
                    ...(searchText !== undefined && searchText !== null && searchText !== "" && { searchText }),
                    ...(sortBy !== undefined && sortBy !== null && { sortBy }),
                    ...(sortDir !== undefined && sortDir !== null && { sortDir }),
                },
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            providesTags: ["StudentNotification"],
        }),
        getStudentNotificationById: builder.query({
            query: (id) => ({
                url: `/util/notification/${id}`,
                method: "GET",
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addStudentNotification: builder.mutation({
            query: ({ requestDTO, file }) => ({
                url: `/util/notification`,
                method: "POST",
                body: buildFormData({ requestDTO, file }),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            invalidatesTags: ["StudentNotification"],
        }),
        updateStudentNotification: builder.mutation({
            query: ({ requestDTO, file }) => ({
                url: `/util/notification`,
                method: "PUT",
                body: buildFormData({ requestDTO, file }),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            invalidatesTags: ["StudentNotification"],
        }),
        deleteStudentNotification: builder.mutation({
            query: (id) => ({
                url: `/util/notification/${id}`,
                method: "DELETE",
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            invalidatesTags: ["StudentNotification"],
        }),
        publishStudentNotification: builder.mutation({
            query: (id) => ({
                url: `/util/notification/${id}`,
                method: "POST",
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            invalidatesTags: ["StudentNotification"],
        }),
    }),
});

export const {
    useGetStudentNotificationListQuery,
    useLazyGetStudentNotificationListQuery,
    useGetStudentNotificationByIdQuery,
    useLazyGetStudentNotificationByIdQuery,
    useAddStudentNotificationMutation,
    useUpdateStudentNotificationMutation,
    useDeleteStudentNotificationMutation,
    usePublishStudentNotificationMutation,
} = studentNotificationAPI;

export default studentNotificationAPI;

